export default "__VITE_PUBLIC_ASSET__6701f165__"